module.exports = __webpack_public_path__ + "img/image02_sp.e2a5784c.jpg";